import Tickmark from './Tickmark'

export default Tickmark
